export default function Button({
  children,
  variant = "primary",
  size = "md",
  className = "",
  type = "button",
  ...props
}) {
  const base = "inline-flex items-center justify-center gap-2 font-medium rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed";
  const sizes = {
    sm: "px-3 py-1.5 text-sm",
    md: "px-4 py-2 text-sm",
    lg: "px-5 py-2.5 text-base",
  };
  const variants = {
    primary: "bg-brand-blue text-white hover:bg-brand-blue-dark",
    secondary: "bg-white border border-gray-200 text-brand-ink hover:bg-gray-50 dark:bg-[var(--bg-soft)] dark:border-[var(--border-soft)] dark:text-[var(--text-primary)] dark:hover:bg-[var(--bg-surface)]",
    accent: "bg-brand-orange text-white hover:bg-orange-600",
    ghost: "text-brand-slate hover:bg-gray-100 dark:hover:bg-[var(--bg-soft)]",
    danger: "bg-red-600 text-white hover:bg-red-700",
    success: "bg-emerald-600 text-white hover:bg-emerald-700",
  };
  return (
    <button
      type={type}
      className={`${base} ${sizes[size]} ${variants[variant]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}